import gql from 'graphql-tag';

export const UPDATE_PROJECT = gql`
  mutation UpdateProject(
    $projectId: String!
    $name: String!
    $description: String
    $projectCode: String
    $accountingCode: String
    $accountingCodeSuffix: String
    $sectors: [String]
    $budget: Float
    $proposedBudget: Float
    $jobName: String
    $clientId: String
    $globallyVisible: Boolean
    $complete: Boolean
    $status: String
    $owner: String
    $totalBilledAmount: Float
    $actualHoursRemaining: Float
    $startDate: Date
    $showEndClient: Boolean
  ) {
    updateProject(
      projectId: $projectId
      name: $name
      description: $description
      projectCode: $projectCode
      accountingCode: $accountingCode
      accountingCodeSuffix: $accountingCodeSuffix
      sectors: $sectors
      budget: $budget
      proposedBudget: $proposedBudget
      jobName: $jobName
      clientId: $clientId
      globallyVisible: $globallyVisible
      complete: $complete 
      status: $status
      owner: $owner
      totalBilledAmount: $totalBilledAmount
      actualHoursRemaining: $actualHoursRemaining
      startDate: $startDate
      showEndClient: $showEndClient
    )
  }
`;

export const UPDATE_PROJECT_TEMPLATE = gql`
  mutation UpdateProject(
    $projectId: String!
    $name: String!
    $description: String!
  ) {
    updateProject(
      projectId: $projectId
      name: $name
      description: $description
    )
  }
`;
